import { gql } from "apollo-boost";

export const regionsTree = gql`
  {
    regions {
      id
      name
      divisions {
        id
        name
        communities {
          id
          name
        }
      }
    }
  }
`;

export const regions = gql`
  {
    regions {
      id
      name
      directorId
      director {
        id
        name
      }
      directorIds
      directors {
        id
        name
      }
      createDate
    }
  }
`;

export const regions2 = gql`
  {
    regions {
      id
      name
      directorId
      director {
        id
        name
      }
      directorIds
      directors {
        id
        name
      }
      createDate
    }
    divisions {
      id
      name
      regionId
      zoneId
      directorId
      director {
        id
        name
      }
      directorIds
      directors {
        id
        name
      }
    }
  }
`;

export const saveRegion = gql`
  mutation saveRegion($input: SaveRegionInput!) {
    saveRegion(input: $input)
  }
`;

export const checkRegion = gql`
  query checkRegion($input: CheckRegionInput!) {
    checkRegion(input: $input)
  }
`;

export const regionGql = {
  regions,
  saveRegion,
  checkRegion,
  regionsTree,
  regions2,
};
